//    Copyright 2020 Siemens
import {default as SPLM} from "../no/splm.js";
import "../no/PDM.js";
import "../no/TaggedObject.js";
let d=[[],[[["nEffectivityRows","effectivityRows"],"GetEffectivityRows",{},0,0],[[],"CreateNewEffectivityRow",{R_:{effectivityRow:"PDM.EffectivityTableRow"}},0,0],[["effectivityRow"],"AddEffectivityRow",{},1,0],[["effectivityRows"],"RemoveEffectivityRows",{},1,0],[["cd","validationBasisFormula","effectivityFormulae"],"UpdateBuilderDetails",{},3,0],[[],"Commit",{},0,0],[[],"Validate",{R_:{result:''}},0,0]],[]];
SPLM.PDM.EffectivityTableBuilder = class extends SPLM.TaggedObject{
    constructor (creator){
        super(creator);
        this._d['Class'] = "SPLM.PDM.EffectivityTableBuilder";
        SPLM.c$d(this.Class,d);d=[];
    }
};

export default SPLM;